module.exports = __webpack_public_path__ + "static/media/PictoRevisaoIPO_2pt.9557aa04.svg";